import { cpf } from './cpf'

export function formatDocument(document: string | undefined, documentType?: 'cpf' | 'passport'): string {
  if (!document) return 'N/A'
  if (documentType === 'passport') return document
  return cpf(document)
}
